export default "__VITE_ASSET__DhNFtHIR__"